// Contact information for Samir Djelal
const contact = {
  email: "ssdjelal@gmail.com",
  location: "Algiers, DZ",
  website: "https://samirdjelal.com",
  linkedin: "https://linkedin.com/in/samirdjelal",
  github: "https://github.com/samirdjelal"
};

export default contact;